import { ActiveModel, ActiveField } from '@alt-point/active-models/src'

/**
* Class OrderCdekDeliveryTimes
*  Сроки доставки (калькулятор + Extra*).
*/
export class OrderCdekDeliveryTimes extends ActiveModel {

  /**
  * periodMin
  * Минимальное время доставки (в рабочих днях)<br>  */
  @ActiveField(0)
  periodMin: number = 0


  /**
  * periodMax
  * Максимальное время доставки (в рабочих днях)<br>  */
  @ActiveField(0)
  periodMax: number = 0


  /**
  * calendarMin
  * Минимальное время доставки (в календарных днях)<br>  */
  @ActiveField(null)
  calendarMin: null | number = null


  /**
  * calendarMax
  * Максимальное время доставки (в календарных днях)<br>  */
  @ActiveField(null)
  calendarMax: null | number = null


/**
  * dateMin
  * Минимальная дата<br>
  */
  @ActiveField(null)
  dateMin: null | string = null


/**
  * dateMax
  * Максимальная дата<br>
  */
  @ActiveField(null)
  dateMax: null | string = null
}
